export default __webpack_public_path__ + "static/media/banner3.30d85bd8.jpg";